/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { NavLink, useHistory } from "react-router-dom";
import {
  ProSidebarProvider,
  Sidebar,
  Menu,
  SubMenu,
  MenuItem,
} from "react-pro-sidebar";
import { useSelector, useDispatch } from "react-redux";
// import "react-pro-sidebar/dist/css/styles.css";
import "./leftpanel-member.css";
import RedeemEscapeBuckCodeModal from "../RedeemEscapeBuckCodeModal";
import LoadingOverlay from "react-loading-overlay";
import {
  Plane_Img,
  Shopping_Img,
  Palm_Img,
  PlayIcon,
  Dollar_Img,
  Dollars_Escape,
  CErtificates,
  Home_Img,
} from "../../assets/images";
import axios from "../../axios/axios";
import { message } from "antd";
import apiConfig from "../../config/api.config";
import countryConfig from "../../config/country.config";
import StarAccessModal from "../../components/star-access-modal";
import {
  setEscapeBuckRedeemModal,
  setApiCallForFetchingEscapeBuckAmount,
  setEscapeBuckAmount,
} from "../../actions/escapeBucks.actions";
import TravelPortalModel from "../TravelPortalModal";

const LeftpanelMember = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [user, setUser] = useState(
    localStorage.getItem("userDetails")
      ? JSON.parse(localStorage.getItem("userDetails"))
      : null,
  );
  const [arriviaUserId, setArriviaUserId] = useState(
    user ? user.arriviaUserId : null,
  );
  const [menuPermission, setMenuPermission] = useState(null);

  const [show, setShow] = useState(false);
  const [first, setFirst] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [last, setLast] = useState("");
  const [address, setAddress] = useState("");
  const [arrivia_password, setArriviaPassword] = useState("");
  const [loadTravel, setLoadTravel] = useState("");
  const [starAccessModalShow, setStarAccessModalShow] = useState(false);
  const escapeBuckAmount = useSelector(
    (state) => state.escapeBucksRedux.escapeBuckAmount,
  );
  const isApiCallForFetchingEscapeCredits = useSelector(
    (state) => state.escapeBucksRedux.isApiCallForFetchingEscapeBuckAmount,
  );
  const [arriviaLoader, setArriviaLoader] = useState(false);

  useEffect(() => {
    if (user) {
      const serviceAccess = JSON.parse(localStorage.getItem("serviceAccess"));
      setMenuPermission(serviceAccess);
    }
  }, [user]);

  const modalClose = () => {
    // setLoadTravel(false);
    setShow(false);
  };

  const starModalCose = () => {
    setStarAccessModalShow(false);
  };

  const handleFirst = (event) => {
    switch (event.target.name) {
      case "first":
        setFirst(event.target.value);
        break;
      case "last":
        setLast(event.target.value);
        break;

      case "address":
        setAddress(event.target.value);
        break;
      case "city":
        setCity(event.target.value);
        break;
      case "phone":
        setPhone(event.target.value);
        break;
      case "arrivia_password":
        setArriviaPassword(event.target.value);
        break;

      default:
        setCountry(event.target.value);
        break;
    }
  };
  const modalShow = () => setShow(true);

  const arriviaRegister = async () => {
    let isRegistered = false;
    if (
      !first ||
      !phone ||
      !city ||
      !country ||
      !last ||
      !address ||
      !arrivia_password
    ) {
      console.log(first);
      message.warning("Please fill up the form properly");
    } else {
      if (arrivia_password.length < 8) {
        message.warning("Password should be at least 8 characters");
        return;
      }
      setArriviaLoader(true);
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("AuthToken")}`,
        },
      };

      let data = {
        firstName: first,
        lastName: last,
        phone,
        country,
        city,
        address,
        password: arrivia_password,
      };
      await axios
        .post(`${apiConfig.api}user/arrivia_register_prife`, data, config)
        .then((res) => {
          if (res.data.status) {
            modalClose();
            setArriviaLoader(false);
            message.warning("Registering to Dashboard, please wait");
            setArriviaUserId(res.data.data);
            let userDetails = JSON.parse(localStorage.getItem("userDetails"));

            userDetails.arriviaUserId = res.data.uId;

            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            isRegistered = true;

            let arrivi = res.data?.arriCred?.arriviaRedirectUrl;
            window.open(arrivi + res.data.data, "_blank");
            // window.open(apiConfig.arriviaRedirectUrl + res.data.data, "_blank");
          } else {
            setArriviaLoader(false);
            message.error("Something went wrong. Login failed!");
          }
        })
        .catch((err) => {
          setArriviaLoader(false);
          console.log("err", err);
          message.error(
            err.response.data.message ??
            "Something went wrong. Please try again letter",
          );
        });

      if (isRegistered) {
        modalClose();
        setArriviaLoader(false);
        message.success("User is successfully registered");
      } else {
        setArriviaLoader(false);
      }
    }
  };

  const arriviaLogin = async () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("AuthToken")}` },
    };
    if (!arriviaUserId) {
      // window.open("/", "_self");
      modalShow();
      return 0;
    }
    // setLoadTravel(true);
    // else message.success("Red, please wait");
    setArriviaLoader(true);
    message.success("Redirecting to dashboard. Please wait...");
    await axios
      .post(`${apiConfig.api}user/arrivia_login_prife`, {}, config)
      .then((res) => {
        setArriviaLoader(false);
        if (res.data.status) {
          setLoadTravel(false);
          let arrivi = res.data?.arriCred?.arriviaRedirectUrl;
          window.open(arrivi + res.data.data);
          // window.open(apiConfig.arriviaRedirectUrl + res.data.data, "_blank");
        } else {
          message.error("Something went wrong. Login failed!");
        }
      })
      .catch((err) => {
        setArriviaLoader(false);
        console.log("err", err);
        setLoadTravel(false);
        message.error(
          err.response.data.message ??
          "Something went wrong. Please try again letter",
        );
      });
  };

  const fetchEscapeBuckAmount = async () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("AuthToken")}` },
    };
    axios
      .get("/user/get-total-escape-bucks", config)
      .then((res) => {
        if (res.data.status) {
          dispatch(setEscapeBuckAmount(res.data.data));
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Something went wrong");
      });
  };

  useEffect(() => {
    if (isApiCallForFetchingEscapeCredits) {
      fetchEscapeBuckAmount();
      dispatch(setApiCallForFetchingEscapeBuckAmount(false));
    }
  }, [isApiCallForFetchingEscapeCredits]);

  return (
    <>
      <ProSidebarProvider>
        <Sidebar>
          <Menu>
            <div className="left_panel_partts">
              <Nav as="ul" className="ml-auto mr-auto nav_dash">
                <Nav.Item as="li">
                  <NavLink exact to="/">
                    <span className="dasg__imgg">
                      <img src={Home_Img} alt="" />
                    </span>
                    <span>Home </span>
                  </NavLink>
                </Nav.Item>
                {menuPermission?.escape_credits && (
                  <Nav.Item as="li">
                    <NavLink
                      exact
                      onClick={() => {
                        dispatch(setEscapeBuckRedeemModal(true));
                      }}
                      to="#"
                    >
                      <span className="dasg__imgg">
                        <img src={Dollar_Img} alt="" />
                      </span>
                      <span>Code Redemption </span>
                    </NavLink>
                  </Nav.Item>
                )}
                <Nav.Item as="li">
                  <NavLink
                    exact
                    // onClick={() => {
                    //   window.open(
                    //     "https://www.tripvalet.com/escape-trips",
                    //     "_blank",
                    //   );
                    // }}
                    to="#"
                  >
                    <span className="dasg__imgg">
                      <img src={Palm_Img} alt="" />
                    </span>
                    <span>Escape Trips </span>
                  </NavLink>
                </Nav.Item>
                <Nav.Item as="li">
                  <NavLink exact to="#" onClick={arriviaLogin}>
                    <span className="dasg__imgg">
                      <img src={Plane_Img} alt="" />
                    </span>
                    <span>VIP Travel Portal </span>
                  </NavLink>
                </Nav.Item>
                {menuPermission?.white_level_dream_certificate && (
                  <SubMenu
                    label="Vacation Certificate"
                    icon={<img src={CErtificates} alt="Certificates" />}
                  >
                    <MenuItem href="/travel-certificates">Send</MenuItem>
                    <MenuItem href="/print">Print</MenuItem>
                  </SubMenu>
                )}

                <Nav.Item as="li">
                  <NavLink
                    exact
                    onClick={() => {
                      window.open(
                        "https://tapi.tripvaletincentives.com/user/benifithub",
                        "",
                      );
                    }}
                    to="#"
                  >
                    <span className="dasg__imgg">
                      <img src={Shopping_Img} alt="" />
                    </span>
                    <span>Shopping and Entertainment</span>
                  </NavLink>
                </Nav.Item>
                <Nav.Item as="li">
                  <NavLink
                    exact
                    onClick={() => {
                      window.open(
                        "https://www.youtube.com/playlist?list=PLlU3YVtkpZ8IEFaNgrUzcEvzQrIsC-glD",
                        "_blank",
                      );
                    }}
                    to="#"
                  >
                    <span className="dasg__imgg">
                      <img src={PlayIcon} alt="" />
                    </span>
                    <span>Training Videos</span>
                  </NavLink>
                </Nav.Item>

                {menuPermission?.escape_credits && (
                  <Nav.Item as="li">
                    <div
                      className="escape-credits-card"
                      onClick={() => {
                        history.push("/my-account?escapeTab=1");
                      }}
                    >
                      <div className="credits-left">
                        <span className="credits-title">Escape Credits</span>
                        <div className="credits-icon">
                          <img
                            src={Dollars_Escape}
                            width={100}
                            alt="Escape Credits"
                          />
                        </div>
                      </div>

                      <div className="credits-right">
                        <div className="credits-amount">
                          {escapeBuckAmount}{" "}
                          <span className="credits-label">Credits</span>
                        </div>
                        <div className="credits-note">No Cash Value.</div>
                      </div>
                    </div>
                  </Nav.Item>
                )}

                <Nav.Item as="li">
                  <NavLink exact to="/my-account">
                    <span className="dasg__imgg">
                      <img
                        src="https://tvi-api.s3.us-east-2.amazonaws.com/MyAccount.png"
                        alt=""
                      />
                    </span>
                    <span>My Account</span>
                  </NavLink>
                </Nav.Item>
              </Nav>
            </div>
          </Menu>
        </Sidebar>
      </ProSidebarProvider>

      <StarAccessModal
        show={starAccessModalShow}
        starModalCose={starModalCose}
      />
      <LoadingOverlay
        active={loadTravel || arriviaLoader}
        spinner
        text="Redirecting to TravelDeals Dashboard...Please wait.."
      ></LoadingOverlay>
      <TravelPortalModel
        show={show}
        modalClose={modalClose}
        first={first}
        last={last}
        phone={phone}
        address={address}
        city={city}
        country={country}
        arrivia_password={arrivia_password}
        arriviaLoader={arriviaLoader}
        handleFirst={handleFirst}
        countryConfig={countryConfig}
        arriviaRegister={arriviaRegister}
      />

      <RedeemEscapeBuckCodeModal />
    </>
  );
};

export default LeftpanelMember;
